import React, { useMemo, useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useDeliveriesUIContext } from '../DeliveriesUIContext';
import axios, { baseUrl } from '../../../../../redux/my-axios';
import { deliverStatusList } from '../DeliveriesUIHelpers';

const PARAM_URL = '/params';
const prepareFilter = (queryParams, values) => {
  const { from, to, searchText, status, deliverType } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  filter.status = status !== '' ? status : undefined;
  filter.from = from; // : new Date().toISOString().slice(0, 10);
  filter.to = to; // !== "" ? +to : new Date().toISOString().slice(0, 10);//to !== "" ? +to : Date.now();
  if (searchText) {
    filter.searchText = searchText;
  }
  newQueryParams.filter = filter;
  return newQueryParams;
};

const DeliveriesFilter = (props) => {
  const [loaded, setLoaded] = useState(false);
  const DeliveriesUIContext = useDeliveriesUIContext();
  const DeliveriesUIProps = useMemo(() => {
    return {
      queryParams: DeliveriesUIContext.queryParams,
      setQueryParams: DeliveriesUIContext.setQueryParams,
    };
  }, [DeliveriesUIContext]);

  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(DeliveriesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, DeliveriesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      DeliveriesUIProps.setQueryParams(newQueryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          from: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 60)
            .toISOString()
            .slice(0, 10),
          to: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30)
            .toISOString()
            .slice(0, 10),
          status: -1,
          searchText: '',
        }}
        onSubmit={(values) => {
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className='form form-label-right'>
            <div className='form-group row'>
              <div className='col-lg-2'>
                <div
                  style={{
                    display: 'inline-flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <input
                    type='date'
                    className='form-control'
                    placeholder='-с'
                    onBlur={handleBlur}
                    value={values.from}
                    onChange={(e) => {
                      setFieldValue('from', e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className='form-text text-muted'>
                    <b>
                      <FormattedMessage id='DELIVERIES.LABEL.FROM' />
                    </b>
                  </small>
                </div>
              </div>
              <div className='col-lg-2'>
                <div
                  style={{
                    display: 'inline-flex',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <input
                    type='date'
                    className='form-control'
                    name='to'
                    onBlur={handleBlur}
                    value={values.to}
                    onChange={(e) => {
                      setFieldValue('to', e.target.value);
                      handleSubmit();
                    }}
                  />
                  <small className='form-text text-muted'>
                    <b>
                      <FormattedMessage id='DELIVERIES.LABEL.TO' />
                    </b>
                  </small>
                </div>
              </div>
              {/*  <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='deliverType'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('deliverType', e.target.value);
                    handleSubmit();
                  }}
                  value={values.deliverType}
                >
                  {deliverTypeList.map((option) => (
                    <option
                      key={`deliverTypeList${option.key}`}
                      value={option.key}
                    >
                      {option.value}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='status'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('status', e.target.value);
                    handleSubmit();
                  }}
                  value={values.status}
                >
                  {deliverStatusList.map((option) => (
                    <option
                      key={`deliverStatusList${option.key}`}
                      value={option.key}
                    >
                      {option.value}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-lg-4'>
                <input
                  type='text'
                  className='form-control'
                  name='searchText'
                  placeholder='текстээс хайх'
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue('searchText', e.target.value);
                    handleSubmit();
                  }}
                />
              </div>

              <div className='col-lg-2'>
                <button
                  id='kt_order_search_submit'
                  type='submit'
                  /* disabled={formik.isSubmitting} */
                  className={`btn btn-primary font-weight-bold `}
                  /* onClick={() => {
                                    //setFieldValue("loading", true);
                                    handleSubmit();
                                }} */
                >
                  <FormattedMessage id='DELIVERIES.LABEL.SEARCH' />
                  {/*   <span><FormattedMessage id="AUTH.LOGIN.BUTTON" /></span> */}
                  {/* {values.loading && <span className="ml-3 spinner spinner-white"></span>} */}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default injectIntl(DeliveriesFilter);
